export enum GiftTabType {
  Gifts = 'gifts',
  UserGifts = 'userGifts',
}

export enum GiftType {
  UserGift = 'userGift',
  Ticket = 'ticket',
  // Призы на вкладке "Можно выиграть". Хранятся в ресурсах
  Static = 'static',
}

export enum ResultGiftType {
  Stocks = 'Stocks',
  Money = 'Money',
  TShop = 'TShop',
}

export enum GiftsIconDefaultType {
  Default1 = 'default1',
  Default2 = 'default2',
  Default3 = 'default3',
  Default4 = 'default4',
  Default5 = 'default5',
}

export enum GiftsIconType {
  TPro = 't-pro',
  VK = 'vk',
  TPremium = 't-premium',
  TTravel = 't-travel',
  TInsurance = 't-insurance',
  TInvest = 't-invest',
  TAfisha = 't-afisha',
  TSupermarkets = 't-supermarkets',
  TFuel = 't-fuel',
  TShopping = 't-shopping',
  YandexPlus = 'yandex-plus',
  YandexLavka = 'yandex-lavka',
  Yandex360 = 'yandex-360',
  SberKuper = 'sber-kuper',
  TastyCoffee = 'tasty-coffee',
  WineLab = 'wine-lab',
  Delimobil = 'delimobil',
  Podruzka = 'podruzka',
  Start = 'start',
  SkyEng = 'sky-eng',
  Common = 'common',
}

export enum GiftStatus {
  ToClaim = 'to-claim',
  Pending = 'pending',
  Received = 'received',
}

export const GIFT_NEW_STATUS_UPDATE_DELAY_MS = 5000;
